/**
 * Nav keyword search.
 */
(() => {
  // Exit if the sidebar is hidden.
  const sidebar = document.querySelector(".md-sidebar--primary");
  const searchBox = document.querySelector("#search-box-nav");
  if (!sidebar || sidebar.hasAttribute("hidden") || !searchBox) {
    return;
  }

  /**
   * Expands parent elements to ensure they are visible.
   * @param {HTMLElement} element - The element whose parents need to be expanded.
   */
  function expandParents(element) {
    if (!element) return;
    const parentNav = element.closest(".md-nav");
    if (parentNav) {
      const parentItem = parentNav.closest(".md-nav__item");
      if (parentItem) {
        const toggle = parentItem.querySelector(".md-nav__toggle");
        if (toggle) {
          toggle.checked = true;
          parentItem.classList.remove("hidden");
          expandParents(parentItem);
        }
      }
    }
  }

  /**
   * Expands all child elements to ensure they are visible.
   * @param {HTMLElement} element - The element whose children need to be expanded.
   */
  function expandAllChildren(element) {
    const childItems = element.querySelectorAll(".md-nav__item");
    childItems.forEach((childItem) => {
      const toggle = childItem.querySelector(".md-nav__toggle");
      if (toggle) {
        toggle.checked = true;
      }
      childItem.classList.remove("hidden");
    });
  }

  /**
   * Stores the initial state of the navigation.
   * @param {NodeList} navItems - The navigation items to store the state for.
   * @return {Array} - The initial state of the navigation.
   */
  function storeInitialState(navItems) {
    const state = [];
    navItems.forEach((item) => {
      const toggle = item.querySelector(".md-nav__toggle");
      state.push({
        item,
        isHidden: item.classList.contains("hidden"),
        isChecked: toggle ? toggle.checked : false,
      });
    });
    return state;
  }

  /**
   * Restores the initial state of the navigation.
   * @param {Array} state - The initial state of the navigation to restore.
   */
  function restoreInitialState(state) {
    state.forEach(({ item, isHidden, isChecked }) => {
      const toggle = item.querySelector(".md-nav__toggle");
      if (isHidden) {
        item.classList.add("hidden");
      } else {
        item.classList.remove("hidden");
      }
      if (toggle) {
        toggle.checked = isChecked;
      }
    });
  }

  /**
   * Highlights the matching text in an element.
   * @param {HTMLElement} element - The element containing the text to highlight.
   * @param {string} query - The search query to highlight.
   */
  function highlightText(element, query) {
    const child = element.querySelector(".md-ellipsis");
    if (child) {
      element = child;
    }
    const text = element.textContent;
    const regex = new RegExp(`(${query})`, "gi");
    const highlightedText = text.replace(regex, '<span class="highlight">$1</span>');
    element.innerHTML = highlightedText;
  }

  /**
   * Clears any existing highlighted links.
   */
  function clearAllHighlights() {
    const highlightedElements = document.querySelectorAll(".md-nav__link .highlight");
    highlightedElements.forEach((highlighted) => {
      highlighted.replaceWith(document.createTextNode(highlighted.textContent));
    });
  }

  const navItems = document.querySelectorAll(".md-sidebar--primary .md-nav__item--active .md-nav__item");
  const initialState = storeInitialState(navItems);

  searchBox.addEventListener("input", function (event) {
    clearAllHighlights();
    const query = event.target.value.toLowerCase();
    if (query === "") {
      restoreInitialState(initialState);
      return;
    }
    const itemsToExpandChildren = [];
    navItems.forEach((item) => {
      const link = item.querySelector(".md-nav__link:not(.md-nav--secondary .md-nav__link)");
      if (link) {
        const isMatch = link.textContent.toLowerCase().includes(query);
        const isLinkTag = link.tagName.toLowerCase() === "a";
        if (isMatch) {
          item.classList.remove("hidden");
          expandParents(item);
          highlightText(link, query);
        } else {
          item.classList.add("hidden");
        }
        if (isMatch && !isLinkTag) {
          const childLinks = item.querySelectorAll(".md-nav__link:not(.md-nav--secondary .md-nav__link)");
          let childMatch = false;
          childLinks.forEach((childLink) => {
            if (childLink.textContent.toLowerCase().includes(query) && childLink.tagName.toLowerCase() === "a") {
              childMatch = true;
              expandParents(childLink.closest(".md-nav__item"));
              highlightText(childLink, query);
            }
          });

          if (!childMatch) {
            // Expand all non-link elements that match, unless they already had a child that matched.
            itemsToExpandChildren.push(item);
          }
        }
      }
    });

    // Expand all children of the collected items.
    itemsToExpandChildren.forEach((item) => {
      expandAllChildren(item);
    });
  });
})();
